export const shortButtonBps = {
  md: { span: 5 },
  lg: { span: 3 },
  xl: { span: 2 },
};

export const attachButtonBps = {
  sm: { span: 12 },
  md: { span: 10 },
  lg: { span: 7 },
  xl: { span: 5 },
  xxl: { span: 4 },
};

export const mtgSaveButtonBps = {
  sm: { span: 6 },
  md: { span: 4 },
};

export const attachTableHeaderBps = {
  sm: { span: 12 },
  md: { span: 14 },
  lg: { span: 17 },
  xl: { span: 19 },
  xxl: { span: 20 },
};

export const mtgTableHeaderBps = {
  sm: { span: 18 },
  md: { span: 20 },
};

export const attachTableSeparatorBps = {
  sm: { span: 0 },
  md: { span: 2 },
  lg: { span: 5 },
  xl: { span: 7 },
  xxl: { span: 8 },
};

export const halfColumnBps = {
  sm: { span: 24 },
  md: { span: 24 },
  lg: { span: 12 },
  xl: { span: 12 },
};

export const mtgHalfColumnBps = {
  sm: { span: 24 },
  md: { span: 24 },
  lg: { span: 24 },
  xl: { span: 12 },
};

export const dashboardHalfColumnBps = {
  sm: { span: 24 },
  md: { span: 24 },
  lg: { span: 24 },
  xl: { span: 12 },
};

export const quarterColumnBps = {
  sm: { span: 24 },
  md: { span: 24 },
  lg: { span: 12 },
  xl: { span: 6 },
};

export const faqVideoBps = {
  sm: { span: 24 },
  md: { span: 24 },
  lg: { span: 12 },
  xl: { span: 8 },
  xxl: { span: 6 },
};

export const faqDocumentBps = {
  sm: { span: 12 },
  md: { span: 8 },
  lg: { span: 6 },
  xl: { span: 4 },
  xxl: { span: 2 },
};

export const exportButtonBps = {
  sm: { span: 11 },
  md: { span: 11 },
  lg: { span: 12 },
  xl: { span: 7 },
  xxl: { span: 5 },
};

export const reportTitleBps = {
  sm: { span: 24 },
  md: { span: 24 },
  lg: { span: 12 },
  xl: { span: 8 },
  xxl: { span: 6 },
};

export const exportBarBps = {
  sm: { span: 24 },
  md: { span: 24 },
  lg: { span: 12 },
  xl: { span: 16 },
  xxl: { span: 18 },
};

export const listSearchBarBps = {
  sm: { span: 24 },
  md: { span: 12 },
  lg: { span: 12 },
};

export const addActionBps = {
  sm: { span: 24 },
  md: { span: 12 },
  lg: { span: 12 },
};

export const searchBoxBps = {
  sm: { span: 17 },
  md: { span: 18 },
  lg: { span: 20 },
  xl: { span: 21 },
  xxl: { span: 21 },
};

export const filterDropdownBps = {
  sm: { span: 4 },
  md: { span: 6 },
  lg: { span: 4 },
  xl: { span: 3 },
  xxl: { span: 3 },
};

export const faqHeaderBps = {
  sm: { span: 12 },
  md: { span: 14 },
  lg: { span: 17 },
  xl: { span: 21 },
  xxl: { span: 22 },
};

export const faqButtonBps = {
  sm: { span: 12 },
  md: { span: 10 },
  lg: { span: 7 },
  xl: { span: 3 },
  xxl: { span: 2 },
};
